import * as tslib_1 from "tslib";
import * as React from 'react';
import { resetFeatureFlags } from 'owa-feature-flags';
import { observer } from 'mobx-react';
var styles = require('./FeatureFlagsHeader.scss');
var FeatureFlagsHeader = /** @class */ (function (_super) {
    tslib_1.__extends(FeatureFlagsHeader, _super);
    function FeatureFlagsHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeatureFlagsHeader.prototype.render = function () {
        return (React.createElement("div", { className: styles.container },
            React.createElement("span", { className: styles.resetButton },
                React.createElement("a", { title: "Resets all the features back to their default values", href: "#", onClick: resetFeatureFlags }, "resetFlags"))));
    };
    FeatureFlagsHeader = tslib_1.__decorate([
        observer
    ], FeatureFlagsHeader);
    return FeatureFlagsHeader;
}(React.Component));
export default FeatureFlagsHeader;
//# sourceMappingURL=FeatureFlagsHeader.js.map